import Input from '../Input/Input';
import { AddressCoordinatesInputProps } from './AddressCoordinatesInput.types';
import '../../../styles/SearchInput.css';
import { InputLabelColor } from '../Input/Input.types';
import { useState } from 'react';

export default ({
  features,
  handleSelectedSuggestion = () => null,
  label,
  labelColor = InputLabelColor.Dark,
  error,
  required,
  ...props
}: AddressCoordinatesInputProps) => {

  const [isFocused, setFocused] = useState(false)

  return (
    <div className="input">
      <label
        htmlFor="input-label"
        className="input__label font-bold"
        style={{ color: labelColor === InputLabelColor.Light ? '#fff' : '#000' }}>
        {label} {required && <span style={{ color: 'red' }}>*</span>}
      </label>
      <div className="searchInput">
        <Input  
          id='input-label' 
          onFocus={() => setFocused(true)}
          onBlur={(e) => {
            if (e.relatedTarget?.className !== 'searchInput__item') {
              setFocused(false)
            }
          }}
          {...props} 
        />
        {isFocused && features?.map((feature, featureIndex) => (
          <div
            key={featureIndex}
            tabIndex={featureIndex}
            data-testid='suggestion-item'
            className="searchInput__item"
            onClick={() => {
              handleSelectedSuggestion(feature)
              setFocused(false)
            }}>
            <span>{feature.place_name}</span>
          </div>
        ))}
      </div>
      <span className="input__error">{error}</span>
    </div>
  );
};
